import { showAlert } from "./Alerts";
import { APICall } from "./api";

export const CommonFunctions = () => {
	// Sets the current user role based on roles provided
	const setUserCurrentRole = (roles, selectedRole = null) => {
		roles = JSON.parse(roles);
		const roleCodes = roles.map(item => item.code);
		let userCurrentRole = {};

		if (selectedRole === null) {
			// Filter out roles that are null or for employees
			const validRoles = roles.filter(
				(role) => (role.name !== null && role.tenantId !== 'hp') || !roleCodes.includes("EMPLOYEE")
			);
			if (validRoles.length > 0) {
				userCurrentRole = validRoles[0]; // Assuming we want to set the first valid role
			}
		} else {
			// Find the role that matches the selected role name
			userCurrentRole = roles.find((role) => role.name === selectedRole) || {};
		}

		localStorage.setItem("userCurrentRole", JSON.stringify(userCurrentRole));
		updateUserRole();
	};

	// Updates the current user role based on the selected role index
	const updateUserCurrentRole = (selectedRole, role) => {
		let roles = JSON.parse(localStorage.getItem("userMappedRoles"));
		localStorage.setItem(
			"userCurrentRole",
			JSON.stringify(roles[selectedRole])
		);
		updateUserRole();
		const sroles = roles[selectedRole].code;
		if (sroles.startsWith('GB_')) {
			window.location.href = process.env.REACT_APP_BASE_PATH + "/backend/garbage-dashboard"; // Redirect to the backend page
		} else if (sroles.startsWith('PTR_')) {
			window.location.href = process.env.REACT_APP_BASE_PATH + "/backend/pet-dashboard"; // Redirect to the backend page
		} else if (sroles.startsWith('SITE_')) {
			window.location.href = process.env.REACT_APP_BASE_PATH + "/backend/site-dashboard"; // Redirect to the backend page
		} else if (sroles.startsWith('ASSET_')) {
			window.location.href = process.env.REACT_APP_BASE_PATH + "/backend/asset-dashboard"; // Redirect to the backend page
		} else if (sroles.startsWith('PROPERTY_')) {
			window.location.href = process.env.REACT_APP_BASE_PATH + "/backend/property-view"; // Redirect to the backend page
		} else {
			window.location.href = process.env.REACT_APP_BASE_PATH + "/backend"; // Redirect to the backend page
		}

	};

	// Updates the user role in the localStorage
	const updateUserRole = () => {
		const userInfo = JSON.parse(localStorage.getItem("userInfo"));
		const userCurrentRole = JSON.parse(localStorage.getItem("userCurrentRole"));

		userInfo.roles = [userCurrentRole]; // Store the current role in userInfo
		localStorage.setItem("userInfo", JSON.stringify(userInfo));
	};

	const constructMDMSSearchString = (tanentID, moduleName, masterDetails) => {
		return {
			RequestInfo: {
				authToken: localStorage.getItem("token"),
			},
			MdmsCriteria: {
				tenantId: `${tanentID}`,
				moduleDetails: [
					{
						moduleName: `${moduleName}`,
						masterDetails: [
							{
								name: `${masterDetails}`,
							},
						],
					},
				],
			},
		};
	}
	// get all districts from MDMS
	const getAllDistricts = async () => {
		const postData = constructMDMSSearchString("hp.District", "District", "District")
		try {
			return await APICall(
				`${process.env.REACT_APP_MDMS_REQUEST_URL}`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}
	};
	// get all ULBs with respect to district from MDMS
	const getAllULBsFromDistrict = async (districtName) => {
		const postData = constructMDMSSearchString("hp.Districts", districtName, "ULBS")
		try {
			return await APICall(
				`${process.env.REACT_APP_MDMS_REQUEST_URL}`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}
	}
	// get all wards with respect to ULBs from MDMS

	const getAllWardsFromULBS = async (ulbName) => {
		const postData = constructMDMSSearchString(`hp.${ulbName}`, "wards", "wards")
		try {
			return await APICall(
				`${process.env.REACT_APP_MDMS_REQUEST_URL}`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}
	}
	// get all zones with respect to ULBs from MDMS

	const getAllZonesFromULBS = async (ulbName) => {
		const postData = constructMDMSSearchString(`hp.${ulbName}`, "zones", "zones")
		try {
			return await APICall(
				`${process.env.REACT_APP_MDMS_REQUEST_URL}`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching zones:", error);
		}
	}

	//get trade categories from MDMS

	const getTradeSubCategory = async (selectedCategory) => {
		const postData = constructMDMSSearchString(`hp`, "TradeLicense", selectedCategory)
		try {
			return await APICall(
				`${process.env.REACT_APP_MDMS_REQUEST_URL}`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}
	}

	//get trade categories from MDMS

	const getTradeCategory = async (module) => {
		const postData = constructMDMSSearchString(`hp`, module, 'Categories')
		try {
			return await APICall(
				`${process.env.REACT_APP_MDMS_REQUEST_URL}`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}
	}


	const getCitizenAppStats = async (criteria) => {
		return getCitizenTLStats(criteria);
	}

	// Trade Licens Application Stats
	const getCitizenTLStats = async (criteria = null) => {
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			}
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_TRADE_LICENSE_SERVICE}/tl-services/v1/NewTL/_search${(criteria ? criteria : "")}`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}

	}

	const getTLApplicationData = async (criteria) => {
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			}
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_TRADE_LICENSE_SERVICE}/tl-services/v1/NewTL/_search` + criteria,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}
	}

	const updateNewTLStatus = async (appNo, comments, status, applicationType) => {
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			"Licenses": [
				{
					"comment": comments,
					"applicationNumber": appNo,
					"action": status,
					"applicationType": applicationType,
				}
			],
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_TRADE_LICENSE_SERVICE}/tl-services/v1/NewTL/_update`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}

	}

	const getServiceDocuments = async (serviceName, appNo = '') => {
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),
			},
			"serviceName": serviceName,
			"objectId": appNo,

		}
		try {
			return await APICall(
				`${process.env.REACT_APP_DMS_URL}/dms/fetchServiceDocMapping`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}
	}

	const downloadServiceDocuments = async (appNo) => {
		const postData = {
			"RequestInfo": {
				authToken: localStorage.getItem("token"),
			},
			"id": appNo,

		}
		try {
			return await APICall(
				`${process.env.REACT_APP_DMS_URL}/dms/downloadFile`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error download:", error);
		}
	}


	const formatDate = (dateString) => {
		const options = { year: "numeric", month: "long", day: "numeric" }
		return new Date(dateString).toLocaleDateString(undefined, options)
	}

	const parseStatus = (status) => {
		let appStatus = '';
		switch (status) {
			case "INITIATE":
				appStatus = "Draft";
				break;
			case "FORWARD_TO_VERIFIER":
			case "FORWARD_TO_APPROVER":
				appStatus = "Submitted to Department";
				break;
			case "VERIFY":
				appStatus = "Verified";
				break;
			case "APPROVE":
				appStatus = "Approved";
				break;
			case "RETURN_TO_INITIATOR_FOR_PAYMENT":
				appStatus = "Returned to Citizen for Payment";
				break;
			default:
				appStatus = status;
				break;
		}
		return appStatus;
	}
	const getStatusRowClass = (status) => {
		let className = '';
		switch (status) {
			case 'APPROVE':
				className = 'table-success';
				break;
			case 'FORWARD_TO_VERIFIER':
				className = "table-primary";
				break;
			case 'VERIFY':
			case 'FORWARD_TO_VERIFIER':
			case 'FORWARD_TO_APPROVER':
				className = 'table-info';
				break;
			case 'RETURN_TO_INITIATOR':
			case 'RETURN_TO_INITIATOR_FOR_PAYMENT':
				className = 'table-warning';
				break;

			default:
				className = 'table-primary';
				break;
		}
		return className;
	}

	const loadScript = (src) => {
		return new Promise((resolve) => {
			const script = document.createElement("script");
			script.src = src;
			script.onload = () => {
				resolve(true);
			};
			script.onerror = () => {
				resolve(false);
			};
			document.body.appendChild(script);
		});
	}
	const getNewTLPaymentDetails = async (applicationNo, accountId = null, uuids) => {
		const applicationNumbers = [applicationNo];
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			"applicationNumbers": applicationNumbers,
			"uuids": [uuids]
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_TRADE_LICENSE_SERVICE}/tl-services/v1/fetch/CALCULATEFEE`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}
	}
	const getPaymentDetails = async (service, application, accountId = null, uuids) => {
		let paymentDetails = '';
		switch (service) {
			case "NewTL":
				paymentDetails = await getNewTLPaymentDetails(application, accountId, uuids)
				break;
			case "GB":
				paymentDetails = await getNewGBPaymentDetails(application, accountId)
				break;
			case "PTR":
				paymentDetails = await getPetPaymentDetails(application, accountId)
				break;
			case "ADVT":
				paymentDetails = await getSiteBookingPaymentDetails(application, accountId)
				break;
			case "chb-services":
				paymentDetails = await getAssetBookingPaymentDetails(application, accountId)
				break;
			default:
				break;
		}
		return paymentDetails;
	}

	/* ******************************************************  Payment RazorPay *********************************************** */

	const initiateTransaction = async (module, appID, billId, billAmount, tenantId,  moduletype='RAZORPAY') => {
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			"Transaction": {
				"tenantId": tenantId,
				"txnAmount": billAmount,
				"module": module,
				"billId": billId,
				"moduleId": "prop12-assess1",
				"productInfo": module,
				"gateway": moduletype,
				"callbackUrl": `${process.env.REACT_APP_TRANSACTION_URL}/v1/_update`,
				"taxAndPayments": [
					{
						"taxAmount": 0,
						"amountPaid": billAmount,
						"billId": billId
					}
				],
				"consumerCode": appID,
				"user": JSON.parse(localStorage.getItem("userInfo")),
			}
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_TRANSACTION_URL}/v1/_create`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}

	}

	const updateTransaction = async (url, queryParam) => {
		url = url + queryParam;
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
		}
		try {
			return await APICall(
				url,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}

	}

	const getTransactionDetails = async (queryParams) => {
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_TRANSACTION_URL}/v1/_search?${queryParams}`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.log(error);
			//  showAlert('Error', 'Token validation failed', 'error');
		}
	}



	const getCategory = async (module, tenantId) => {
		const postData = constructMDMSSearchString(tenantId, module, 'Categories')
		try {
			return await APICall(
				`${process.env.REACT_APP_MDMS_REQUEST_URL}`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}
	}

	/* ******************************************************  Garbage Colllection *********************************************** */

	// Garbage Licens Application Stats

	const getCitizenGarbageAppStats = async (searchparmas) => {
		return getCitizenGarbagStats(searchparmas);
	}

	// Garbage Licens Appliecation Stats
	const getCitizenGarbagStats = async (searchparmas) => {
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			searchCriteriaGarbageAccount: {
				status: searchparmas?.status ? [searchparmas.status.trim()] : null,
				applicationNumber: searchparmas?.grbgApplicationNumber ? [searchparmas.grbgApplicationNumber.trim()] : null,
				wardNames: searchparmas?.wardName ? [searchparmas.wardName.trim()] : null,
				mobileNumber: searchparmas?.mobileNumber ? [searchparmas.mobileNumber.trim()] : null,
				oldGarbageIds: searchparmas?.oldGarbageIds ? [searchparmas.oldGarbageIds.trim()] : null,
				unitCategories: searchparmas?.unitCategories ? [searchparmas.unitCategories.trim()] : null,
				name: searchparmas?.name ? [searchparmas.name.trim()] : null,
				user_uuid: searchparmas?.user_uuid ? [localStorage.getItem('userInfo').uui] : null,
				limit: searchparmas?.limit,
				offset: searchparmas?.offset,
				isActiveAccount: true,
				isActiveSubAccount: true
			},
		}
		if (JSON.parse(localStorage.getItem("userCurrentRole")).code !== "CITIZEN") {
			postData.searchCriteriaGarbageAccount.tenantId = JSON.parse(localStorage.getItem("userCurrentRole")).tenantId;
		} else {
			postData.searchCriteriaGarbageAccount.user_uuid = [JSON.parse(localStorage.getItem("userInfo")).uuid];
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_GARBAGE_COLLECTION_SERVICE}/garbage-service/garbage-accounts/_search?IsIndex=true`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching garbage data:", error);
		}

	}
	// Garbage Licens Application Data

	const getGarbageApplicationData = async (criteria) => {
		const queryParams = new URLSearchParams(criteria)
		const applicationNumber = queryParams.get('applicationNumber') ? queryParams.get('applicationNumber') : localStorage.getItem("applicationNumber");
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			searchCriteriaGarbageAccount: {
				applicationNumber: [applicationNumber],
				isActiveAccount: true,
				isActiveSubAccount: true
			}
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_GARBAGE_COLLECTION_SERVICE}/garbage-service/garbage-accounts/_search` + criteria,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching garbage data:", error);
		}
	}

	// Garbage Status Update
	const updateNewGarbageStatus = async (appNo, comments, status, businessService) => {
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			"garbageAccounts": [
				{
					"businessService": businessService,
					"isOnlyWorkflowCall": true,
					"grbgApplicationNumber": appNo,
					"workflowAction": status,
					"workflowComment": comments,
				}
			],
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_GARBAGE_COLLECTION_SERVICE}/garbage-service/garbage-accounts/_update`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}

	}

	// Garbage Payment details
	const getNewGBPaymentDetails = async (applicationNo, accountId = null) => {
		const applicationNumbers = [applicationNo];
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			"applicationNumbers": applicationNumbers
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_GARBAGE_COLLECTION_SERVICE}/garbage-service/garbage-accounts/fetch/CALCULATEFEE`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching payment detail:", error);
		}

	}


	// MDSM fetch master data
	const getMdmseSearch = async (module, service) => {
		const postData = constructMDMSSearchString(`hp`, module, service)
		try {
			return await APICall(
				`${process.env.REACT_APP_MDMS_REQUEST_URL}`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching records:", error);
		}
	}

	/* ********************************************************  Pet Registration *********************************************** */

	// Pet Registration Application Detail
	const getPetApplicationData = async (criteria) => {
		const queryParams = new URLSearchParams(criteria)
		const applicationNumber = queryParams.get('applicationNumber') ? queryParams.get('applicationNumber') : localStorage.getItem("applicationNumber");
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			searchCriteriaGarbageAccount: {
				applicationNumber: [applicationNumber],
			}
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_SERVER_BASE_URL}/pet-services/pet-registration/_search` + criteria,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching garbage data:", error);
		}
	}


	// Pet License Application Stats

	const getCitizenPetAppStats = async (criteria) => {
		return getCitizenPetStats(criteria);
	}

	// Pet License Application Stats
	const getCitizenPetStats = async (criteria = null) => {
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_SERVER_BASE_URL}/pet-services/pet-registration/_search${(criteria ? criteria : "")}`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching pet data:", error);
		}

	}

	// Pet Status Update
	const updatePetStatus = async (appNo, comments, status) => {
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			PetRegistrationApplications: [
				{
					"isOnlyWorkflowCall": true,
					"applicationNumber": appNo,
					"workflow": {
						"action": status,
						"status": null,
						"comments": comments,
						"assignes": null,
						"documents": null
					},
				}
			],
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_SERVER_BASE_URL}/pet-services/pet-registration/_update`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}

	}

	// Pet Payment details
	const getPetPaymentDetails = async (applicationNo, accountId = null) => {
		const applicationNumbers = [applicationNo];
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			"applicationNumbers": applicationNumbers
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_SERVER_BASE_URL}/pet-services/pet-registration/fetch/CALCULATEFEE`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching payment detail:", error);
		}

	}

	/* ********************************************************  Site Registration *************************************************** */

	// Site Registration Application Detail
	const getSiteApplicationData = async (criteria) => {
		const queryParams = new URLSearchParams(criteria)
		const applicationNumber = queryParams.get('applicationNumber') ? queryParams.get('applicationNumber') : localStorage.getItem("applicationNumber");
		const postData = {
			"RequestInfo": {
				authToken: localStorage.getItem("token"),
			},
			searchData: {
				siteID: applicationNumber || null,
				active: queryParams.get('active') || true, // Always set to true as per your requirements
			}
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_ADVERTISEMENT_SERVICE}/adrvcanopy-services/site/_search` + criteria,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching garbage data:", error);
		}
	}

	// Site License Application Stats

	const getCitizenSiteAppStats = async (criteria) => {
		return getCitizenSiteStats(criteria);
	}

	// Site License Application Stats
	const getCitizenSiteStats = async (criteria = null) => {
		const queryParams = new URLSearchParams(criteria)
		const applicationNumber = queryParams.get('applicationNumber') ? queryParams.get('applicationNumber') : null;
		const tenantId = queryParams.get('tenantId') ? queryParams.get('tenantId') : null;

		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			searchData: {
				tenantId: tenantId || null,
				districtName: queryParams.get('districtName') || null,
				uuid: queryParams.get('uuid') || null, // Default uuid
				ulbName: queryParams.get('ulbName') || null,
				wardNumber: queryParams.get('wardNumber') || null,
				advertisementType: queryParams.get('advertisementType') || null,
				status: queryParams.get('status') || null,
				siteID: applicationNumber || null,
				active: queryParams.get('active') || true, // Always set to true as per your requirements
			}
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_ADVERTISEMENT_SERVICE}/adrvcanopy-services/site/_search${(criteria ? criteria : "")}`,
				"POST",
				JSON.stringify(postData),
				{
					"Content-Type": "application/json"
				}
			);
		} catch (error) {
			console.error("Error fetching Site data:", error);
		}

	}

	// Site License Application Stats



	const unixFormatDate = (timestamp) => {
		// Convert Unix timestamp to milliseconds
		const date = new Date(timestamp * 1000);
		// Define formatting options
		const options = { year: "numeric", month: "long", day: "numeric" };
		// Format the date
		return date.toLocaleDateString(undefined, options);
	}

	const calculateNoOfDaysFromCreatedTime = (timestamp) => {
		const currentTimestamp = Date.now();
		const difference = currentTimestamp - timestamp;
		const daysElapsed = Math.floor(difference / (1000 * 60 * 60 * 24));
		return daysElapsed;
	};

	/* ******************************************************** Garbage Billing *************************************************** */

	const garbageCitizenBills = async (billStatus) => {
		let appendSTr = "";
		if (billStatus === "ACTIVE") {
			appendSTr = "&status=ACTIVE";
		}
		//const applicationNumbers = ["GB/HP/Shimla/Shimla/112024/1"];
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			"isEmptyBillFilter": true,
			"billStatus": [billStatus]
			// "applicationNumbers": applicationNumbers
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_GARBAGE_COLLECTION_SERVICE}/garbage-service/garbage-accounts/fetch/CALCULATEFEE`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching Site bills:", error);
		}
	};

	const timestampsToDate = (timestamp) => {
		const date = new Date(timestamp);
		const day = String(date.getDate()).padStart(2, "0");
		const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
		const year = date.getFullYear();
		return `${day}-${month}-${year}`;
	};

	// Site Booking Status Update
	const updateSiteStatus = async (id, uuid, appNo, comments, status) => {


		const statusMapping = {
			APPROVE: "APPROVED",
			RETURN_TO_INITIATOR: "PENDINGFORMODIFICATION",
			REJECT: "REJECTED",
			EDIT: "PENDINGFORMODIFICATION"
		};
		const actionMapping = {
			EDIT: "PENDING_FOR_MODIFICATION"
		};
		const finalAction = actionMapping[status] || status;
		const updatedStatus = statusMapping[status] || "UNKNOWN";
		const postData = {
			"RequestInfo": {
				authToken: localStorage.getItem("token"),
			},
			siteUpdationData: {
				id: id,
				uuid: uuid,
				siteID: appNo,
				isOnlyWorkflowCall: true,
				workflowAction: finalAction,
				comments: comments || "Modification",
				workFlowStatus: updatedStatus,
			},
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_ADVERTISEMENT_SERVICE}/adrvcanopy-services/site/_update`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}

	}


	/* ********************************************************  Site Booking *************************************************** */

	// Site Registration Application Detail
	const getSiteBookingApplicationData = async (criteria) => {
		const queryParams = new URLSearchParams(criteria)
		const applicationNumber = queryParams.get('applicationNumber') ? queryParams.get('applicationNumber') : localStorage.getItem("applicationNumber");
		const postData = {
			"RequestInfo": {
				authToken: localStorage.getItem("token"),
			},
			SiteBookingSearchCriteria: {
				applicationNumbers: [applicationNumber]
			}

		}
		if (JSON.parse(localStorage.getItem("userCurrentRole")).code !== "CITIZEN") {
			postData.SiteBookingSearchCriteria.tenantId = JSON.parse(localStorage.getItem("userCurrentRole")).tenantId;
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_ADVERTISEMENT_SERVICE}/adrvcanopy-services/site-booking/_search` + criteria,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching garbage data:", error);
		}
	}

	// Site Booking Application Stats

	const getCitizenSiteBookingAppStats = async (criteria) => {
		return getCitizenSiteBookingStats(criteria);
	}


	// Site Booking Application Stats
	const getCitizenSiteBookingStats = async (criteria = null) => {
		const postData = {
			"RequestInfo": {
				authToken: localStorage.getItem("token"),
			},
			SiteBookingSearchCriteria: {
			}
		}
		if (JSON.parse(localStorage.getItem("userCurrentRole")).code !== "CITIZEN") {
			postData.SiteBookingSearchCriteria.tenantId = JSON.parse(localStorage.getItem("userCurrentRole")).tenantId;
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_ADVERTISEMENT_SERVICE}/adrvcanopy-services/site-booking/_search${(criteria ? criteria : "")}`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching Site data:", error);
		}
	}

	// Site Booking Status Update
	const updateSiteBookingStatus = async (appNo, comments, status) => {
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			SiteBookings: [
				{
					"applicationNo": appNo,
					"isOnlyWorkflowCall": true,
					"workflowAction": status,
					"comments": comments
				}
			],
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_ADVERTISEMENT_SERVICE}/adrvcanopy-services/site-booking/_update`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching districts:", error);
		}

	}

	// Property Booking Status Update
	const updatePropertyStatus = async (appNo, comments, status, workflowType) => {
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			propertyId: appNo,
			workflow: {
				action: status,
				businessService: workflowType,
				moduleName: "PROPERTY",
				comment: comments
			}
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_ADVERTISEMENT_SERVICE}/property-services/property/_updateStatus`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching properties:", error);
		}

	}

	// Site Booking Payment details
	const getSiteBookingPaymentDetails = async (applicationNo, accountId = null) => {
		const applicationNumbers = [applicationNo];
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			"applicationNumbers": applicationNumbers
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_ADVERTISEMENT_SERVICE}/adrvcanopy-services/site-booking/fetch/CALCULATEFEE`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching payment detail:", error);
		}

	}


	/* ******************************************************** Asset Creation ****************************************** */
	const getAssetApplicationData = async (criteria) => {
		const queryParams = new URLSearchParams(criteria)
		const applicationNumber = queryParams.get('applicationNumber') ? queryParams.get('applicationNumber') : localStorage.getItem("applicationNumber");
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_ADVERTISEMENT_SERVICE}/asset-services/v1/assets/_search` + criteria,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching garbage data:", error);
		}
	}


	const getCitizenAssetAppStats = async (criteria) => {
		return getCitizenAssetStats(criteria);
	}

	const getCitizenAssetStats = async (criteria = null) => {
		let url = null;
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),
			},
		}

		url = `${process.env.REACT_APP_ADVERTISEMENT_SERVICE}/asset-services/v1/assets/_search${criteria}`;
		try {
			return await APICall(
				`${url}`,
				"POST",
				JSON.stringify(postData),
				{
					"Content-Type": "application/json",
				}
			);
		} catch (error) {
			console.error("Error fetching Site data:", error);
		}

	}

	// Asset Status Update
	const updateAssetStatus = async (id, appNo, comments, status) => {
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			Asset: [
				{
					"id": id,
					"applicationNo": appNo,
					"isOnlyWorkflowCall": true,
					"workflowAction": status,
					"comments": comments
				}
			],
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_ADVERTISEMENT_SERVICE}/asset-services/v1/assets/_update`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error in update status:", error);
		}

	}

	// Site Booking Payment details
	const getAssetBookingPaymentDetails = async (applicationNo, accountId = null) => {
		const applicationNumbers = [applicationNo];
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			"applicationNumbers": applicationNumbers
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_ADVERTISEMENT_SERVICE}/chb-services/booking/v1/fetch/CALCULATEFEE`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching payment detail:", error);
		}

	}
	const getTradeLicencePaymentDetails = async (applicationNumber) => {
		const postData = {
			RequestInfo: {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),
			},
			applicationNumber: [applicationNumber],
		};
		try {
			const url = `${process.env.REACT_APP_SERVER_BASE_URL}/pg-service/transaction/v1/_search?consumerCode=${applicationNumber}`;
			return await APICall(
				url,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching payment details:", error);
			return null; // Always return something (even on error)
		}
	};
	const getCommunityPaymentDetails = async (tenantId, applicationNumber, assetNo) => {
		const token = localStorage.getItem("token");
		if (!token || !tenantId || !assetNo) {
			console.error("Missing token, tenantId, or applicationNumber");
			return null;
		}
		const assetNumber = assetNo;
		const postData = {
			RequestInfo: {
				authToken: token,
			},
			MdmsCriteria: {
				tenantId,
				moduleDetails: [
					{
						moduleName: "AssetParentCategory",
						masterDetails: [
							{
								name: "AssetCategory",
								filter: `[?(@.UlbName == "${tenantId.split('.')[1]}" && @.assetNumber=="${assetNumber}")]`,
							},
						],
					},
				],
			},
		};
		const url = `${process.env.REACT_APP_SERVER_BASE_URL}/mdms-v2/v1/_search`;
		try {
			const response = await APICall(
				url,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
			const details =
				response?.MdmsRes?.AssetParentCategory?.AssetCategory?.[0] || null;
			return {
				assetDetails: details,
			};
		} catch (error) {
			console.error("Error fetching MDMS asset details:", error);
			return null;
		}
	};

	const getAdvertisementPaymentDetails = async (tenantId, applicationNumber) => {
		const token = localStorage.getItem("token");
		if (!token || !tenantId || !applicationNumber) {
			console.error("Missing token, tenantId, or applicationNumber");
			return null;
		}
		const postData = {
			RequestInfo: {
				apiId: process.env.REACT_APP_APIID,
				authToken: token,
			},
			SiteBookingSearchCriteria: {
				applicationNumbers: [applicationNumber],
				tenantId,
			},
		};
		const url = `${process.env.REACT_APP_SERVER_BASE_URL}/adrvcanopy-services/site-booking/_search?tenantId=${tenantId}&applicationNumber=${applicationNumber}`;
		try {
			return await APICall(
				url,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error fetching advertisement payment details:", error);
			return null;
		}
	};

	// convert blob document to PDF
	const downloadDocument = async (objectId, serviceName, documentId, documentType) => {
		const url = `${process.env.REACT_APP_DMS_URL}/dms/fetchServicebyDocID`;
		const requestBody = {
			RequestInfo: {
				authToken: localStorage.getItem("token"), // Replace with the actual token
			},
			serviceName: serviceName,
			objectId: objectId,
			documentId: documentId,
			documentType: documentType,
		};

		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(requestBody),
			});
			const contentType = response.headers.get('Content-Type');
			if (!response.ok) {
				throw new Error("Failed to fetch document");
			}
			const reader = response.body.getReader();
			const chunks = [];
			const processStream = ({ done, value }) => {
				if (done) {
					const blob = new Blob(chunks, { type: contentType });
					const blobUrl = URL.createObjectURL(blob); // Generate a URL for the Blob
					const newWindow = window.open();
					if (contentType === "application/pdf") {
						newWindow.document.write(`<iframe src="${blobUrl}" width="100%" height="100%" style="border:none;"></iframe>`);
					} else {
						newWindow.document.write(`<img src="${blobUrl}" width="100%" height="100%" />`);
					}
				} else {
					chunks.push(value); // Add chunk to the array
					reader.read().then(processStream); // Continue reading the stream
				}
			}
			reader.read().then(processStream).catch(err => console.error('Error reading stream:', err));
		} catch (error) {
			console.error("Error fetching the document:", error);
		}
	};

	const getCommunityHallBookedDates = async (assetCode) => {
		try {
			const postData = {
				RequestInfo: {
					authToken: localStorage.getItem("token"), // Replace with the actual token
				},
				communityHallCode: assetCode
			};
			return await APICall(
				`${process.env.REACT_APP_SERVER_BASE_URL}/chb-services/booking/v1/_slot-details`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.log(error);
		}
	}

	const updateAssetBookingStatus = async (appNo, comments, status) => {
		const postData = {
			"RequestInfo": {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),

			},
			bookingNo: appNo,
			workflow: {
				action: status,
				businessService: 'chb-services',
				moduleName: "CHB"
			}
		}
		try {
			return await APICall(
				`${process.env.REACT_APP_ADVERTISEMENT_SERVICE}/chb-services/booking/v1/_update_status`,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
		} catch (error) {
			console.error("Error in update status:", error);
		}
	}

	const searchBills = async (filters) => {
		try {
			const postData = {
				RequestInfo: { authToken: localStorage.getItem("token") }
			};

			let uri = `${process.env.REACT_APP_ADVERTISEMENT_SERVICE}/billing-service/bill/v2/_search?tenantId=${filters.tenantId}`;

			Object.keys(filters).forEach(key => {
				if (key !== "tenantId" && filters[key]) {
					uri += `&${key}=${filters[key]}`;
				}
			});

			const res = await APICall(
				uri,
				"POST",
				JSON.stringify(postData),
				{ "Content-Type": "application/json" }
			);
			return res;
		} catch (error) {
			console.log(error);
		}
	};
	const cancelSiteBooking = async (applicationNo, cancelReason) => {
	try {
		const payload = {
			RequestInfo: {
				apiId: process.env.REACT_APP_APIID,
				authToken: localStorage.getItem("token"),
			},
			SiteBookings: [
				{
					applicationNo: applicationNo,
					isOnlyWorkflowCall: true,
					workflowAction: "CANCEL",
					comments: cancelReason,
				},
			],
		};
		return await APICall(
			`${process.env.REACT_APP_SERVER_BASE_URL}/adrvcanopy-services/site-booking/_update`,
			"POST",
			JSON.stringify(payload),
			{ "Content-Type": "application/json" }
		);
	} catch (error) {
		console.error("Error cancelling site booking:", error);
		return null;
	}
};

	return {
		setUserCurrentRole,
		updateUserRole,
		updateUserCurrentRole,
		getAllDistricts,
		getAllULBsFromDistrict,
		getAllWardsFromULBS,
		getAllZonesFromULBS,
		getTradeSubCategory,
		constructMDMSSearchString,
		getCitizenAppStats,
		getTLApplicationData,
		updateNewTLStatus,
		getServiceDocuments,
		downloadServiceDocuments,
		formatDate,
		parseStatus,
		getStatusRowClass,
		loadScript,
		getPaymentDetails,
		getTradeCategory,
		initiateTransaction,
		updateTransaction,
		getTransactionDetails,
		getCategory,
		getCitizenGarbageAppStats,
		getGarbageApplicationData,
		updateNewGarbageStatus,
		getNewGBPaymentDetails,
		getMdmseSearch,
		getPetApplicationData,
		getCitizenPetAppStats,
		updatePetStatus,
		getPetPaymentDetails,
		getSiteApplicationData,
		getAssetApplicationData,
		getCitizenSiteAppStats,
		getCitizenAssetAppStats,
		updateSiteStatus,
		unixFormatDate,
		garbageCitizenBills,
		timestampsToDate,
		getSiteBookingApplicationData,
		getCitizenSiteBookingAppStats,
		updateSiteBookingStatus,
		updatePropertyStatus,
		getTradeLicencePaymentDetails,
		getCommunityPaymentDetails,
		getAdvertisementPaymentDetails,
		downloadDocument,
		updateAssetStatus, getCommunityHallBookedDates, updateAssetBookingStatus,
		searchBills,
		cancelSiteBooking
	};
};
